import { useAnalytics as usePackageAnalytics } from '@3plearning/mx-teacher-analytics/react';

// Returns null outside a provider so isolated tests can no-op.
export default function useAnalyticsClient() {
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return usePackageAnalytics();
  } catch (error) {
    return null;
  }
}



// WEBPACK FOOTER //
// ./analytics/client/use-analytics-client.js